import { useContext } from "react";
import { ConfirmationDialogContext } from "../context/ConfirmDialog";

export const useConfirmDialog = () => {
    const { openDialog } = useContext(ConfirmationDialogContext);

    const getConfirmation = ({ ...options }) =>
        new Promise((res) => {
            openDialog({ actionCallback: res, ...options });
        });

    return { getConfirmation };
};
